import { type UseQueryResult, useQuery } from 'react-query';
import { CompanySsoConfigurationService } from '../../services/wealthlane-identity-services';
import { OptionType } from '../../types/common';

const useGetPPTIdentifierTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<OptionType[] | undefined, unknown> => {
  const pptIdentifierTypes = useQuery(
    ['getPPTIdentifierTypes'],
    async () => {
      return await handleRequest(
        CompanySsoConfigurationService.getApiIdentityApiAppCompanySsoConfigurationPptIdentifierTypes()
      );
    },
    {
      select: (data) => data?.map((item) => ({ label: item, value: item })),
    }
  );

  return pptIdentifierTypes;
};

export default useGetPPTIdentifierTypes;
